export default ["I", "II", "III", "IV"].map(s => {
  return { value: s, text: `Schedule ${s}` };
});
